import React, {Component} from 'react';
import './MainServices.css';
import withAuthorization from "../../services/Authorization";
import CheckboxItem from "./CheckboxItem";
import {injectIntl} from "react-intl";
import {connect} from 'react-redux';
import uuidv4 from 'uuid/v4';
import {Button, Checkbox, Divider} from 'antd';
import Storage from '../../services/Storage'
import LabelEncoder from "./LabelEncoder";
import _ from 'lodash';
import SATimePicker from "../common/input/SATimePicker";
import Time from "../../services/Time";
import Constants from "../../services/Constants";
import SAInputCurrency from "../common/input/SAInputCurrency";
import {SpinnerModal} from "../../public/components/SpinnerModal";

const MAX_SERVICES_TO_ADD = 4;
const MAX_MY_BMW_APP_EXTRA_SERVICE = 10;

class MainServices extends Component {

  constructor(props){
    super(props);
    this.state = {
      services: {
        mainServices: [],
        myBMWAppExtraServices: [],
        myBMWAppServices: [],
        otherServices: [],
        additionalServices: [],
        extraServices: []
      },
      additionalServiceId: 0
    }
  }
  componentDidMount(){
    this.props.dispatchFetchServices();
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.fetchServices && nextProps.fetchServices.services){
      const {extraServices} = nextProps.fetchServices.services;
      if (extraServices && extraServices.length >= 1){
        const maxId = _.maxBy(extraServices, function(b) {
          return b.id;
        });
        this.setState({additionalServiceId: maxId.id + 1})
      }
      this.setState({services:nextProps.fetchServices.services})
    }
  }

  save = ()=>{
    this.props.dispatchSaveServices(this.state.services);
  }

  onCheckboxItemChange = (name, state, category) => {
    const {services} = this.state;
    services[category][name] = state;
    this.setState({services});
  }

  onValidateExtraService = (values) => {
    const {services} = this.state
    if (!services.extraServices) {
      services.extraServices = [];
    }

    const filtered = services.extraServices.filter(service => service.id === values.id);
    if (filtered && filtered.length >= 1) {
      filtered[0].mlItem = values;
      filtered[0].active = true;
      this.setState({services});
    } else {
      services.extraServices.push({id: values.id, mlItem: values, active: true});
      this.setState({services, additionalServiceId: this.state.additionalServiceId + 1});
    }

    this.setState({});
  }

  onValidateAdditionalService = (values, category) => {
    const {services} = this.state;

    if (!services[category]) {
      services[category] = [];
    }

    const found = services[category].find(service => service.id === values.id)
    if (found) {
      found.mlItem = values;
    } else {
      services[category].push({
        active: true,
        id: values.id,
        mlItem: values,
        order: services[category].length
      });
    }
    this.setState({services});
  }

  onTimePickerChange = (time, timeString, id, category) => {
    const {services} = this.state;
    const duration = time ? `PT${time.hour()}H${time.minute()}M` : undefined;

    const filtered = services[category].filter(service => service.id === id);
    if (filtered && filtered.length >= 1){
      filtered[0].duration = duration;
      this.setState({services});
    }
  }
  onInputPriceChange = (number, string, id)=>{
    const {services} = this.state;

    const filtered = services.extraServices.filter(service=>service.id === id);
    if (filtered && filtered.length >= 1){
      filtered[0].price = number;
      this.setState({services});
    }
  }

  removeAdditionalService = (event, id, category) => {
    event.stopPropagation();
    const {services} = this.state;
    services[category] = services[category].filter(e => id !== e.id);
    services[category].forEach((service, i) => service.order = i);
    this.setState({services});
  }

  renderExtraServices = ()=>{
    const {intl, intl:{formatMessage}, saveServices} = this.props;
    const {services} = this.state;
    const user = Storage.getItem('user');
    const canWrite= user.role === 'DUI_ADMIN';
    const error = saveServices && saveServices.error && saveServices.error.content;
    let elements = [];

    if (!services.extraServices){
      return null;
    }

    services.extraServices.forEach((service, i)=>{
      elements.push(
        <li key={'service.'+i}>
          {canWrite ?
            <React.Fragment>
              <SATimePicker name={"service.duration"}
                            onChange={(time, timeString) => this.onTimePickerChange(time, timeString, service.id, 'extraServices')}
                            className={"right"} placeholder={formatMessage({id: 'placeholder.duration'})}
                            value={service.duration}
                            error={error && error[`extraServices[${i}].duration`]}/>
              <SAInputCurrency name={`service.price`}
                               onChange={(number, string)=>this.onInputPriceChange(number, string, service.id)}
                               className={"right"} placeholder={formatMessage({id:'placeholder.price'})}
                               value={service.price}
                               error={error && error[`extraServices[${i}].price`]} />
            </React.Fragment>
            :
            <span className="right picker-right">{(service.duration) ? Time.durationToMoment(service.duration, 'HH:mm').format('HH:mm') : ''}</span>
          }
          <div className={"d-flex"}>
            <Checkbox checked={true} disabled={true}>
              <span>{service['mlItem'][intl.locale]}</span>
            </Checkbox>
            {canWrite &&
              <LabelEncoder keys={Constants.SUPPORTED_LANGUAGES} labelId={service.id} onValidate={this.onValidateExtraService} values={service.mlItem}>
                <span>
                  &nbsp;
                  <a className={"smaller"}>{formatMessage({id: 'action.edit'})}</a>
                  &nbsp;
                  <a className={"smaller"} onClick={(e) => this.removeAdditionalService(e, service.id, 'extraServices')}>{formatMessage({id: 'action.delete'})}</a>
                </span>
              </LabelEncoder>
            }
          </div>
        </li>
      )
    })
    return elements;
  }

  renderDefaultItem = (item, error, canWrite)=>{
    const {name} = item;
    const err = {
      [`${name}.duration`]: error[`mainServices[${name}].duration`],
      [`${name}.price`]: error[`mainServices[${name}].price`],
      [`${name}.rangeOfKilometers`]: error[`mainServices[${name}].rangeOfKilometers`]
    };
    return <CheckboxItem canWrite={canWrite} onChange={(n, v)=>this.onCheckboxItemChange(n, v, 'mainServices')} name={name} config={{timePicker:true}} item={item} error={err} labelKey={`services.${name}`} placeholderDurationKey={'placeholder.duration'}/>
  }

  renderOtherItem = (item, error, canWrite)=>{
    const {name} = item;
    const err = {
      [`${name}.duration`]: error[`otherServices[${name}].duration`],
      [`${name}.price`]: error[`otherServices[${name}].price`],
      [`${name}.rangeOfKilometers`]: error[`otherServices[${name}].rangeOfKilometers`]
    };
    return <CheckboxItem canWrite={canWrite} onChange={(n, v)=>this.onCheckboxItemChange(n, v, 'otherServices')} name={name} config={{timePicker:true}} item={item} error={err} labelKey={`services.${name}`} placeholderDurationKey={'placeholder.duration'}/>
  }

  renderAdditionalItem = (item, error, canWrite)=>{
    const {name} = item;
    const err = {
      [`${name}.duration`]: error[`additionalServices[${name}].duration`],
      [`${name}.price`]: error[`additionalServices[${name}].price`],
      [`${name}.rangeOfKilometers`]: error[`additionalServices[${name}].rangeOfKilometers`]
    };
    return <CheckboxItem canWrite={canWrite} onChange={(n, v)=>this.onCheckboxItemChange(n, v, 'additionalServices')} name={name} config={{timePicker:true, price:true}} item={item} error={err} labelKey={`services.${name}`} placeholderDurationKey={'placeholder.duration'} placeholderPriceKey={'placeholder.price'}/>
  }

  renderMyBMWAppItem = (item, error, canWrite) => {
    const {name} = item;
    const err = {
      [`${name}.duration`]: error[`myBMWAppServices[${name}].duration`],
    };
    return <CheckboxItem canWrite={canWrite} onChange={(n, v) => this.onCheckboxItemChange(n, v, 'myBMWAppServices')} name={name} config={{timePicker: true}} item={item} error={err} labelKey={`services.${name}`} placeholderDurationKey={'placeholder.duration'}/>
  }

  renderMyBMWAppExtraServices = (errors, canWrite) => {
    const {intl, saveServices} = this.props;
    const {services} = this.state;

    const canAddMyBmwAppExtraService = canWrite && (services.myBMWAppExtraServices || []).length < MAX_MY_BMW_APP_EXTRA_SERVICE;

    return <ul className="list li-margin">
      {services.myBMWAppExtraServices && services.myBMWAppExtraServices.map((service, i) =>
        <li key={'myBMWAppService.' + i}>
          {canWrite ?
            <React.Fragment>
              <SATimePicker name={"service.duration"}
                            onChange={(time, timeString) => this.onTimePickerChange(time, timeString, service.id, 'myBMWAppExtraServices')}
                            className={"right"} placeholder={intl.formatMessage({id: 'placeholder.duration'})}
                            value={service.duration}
                            error={saveServices && saveServices.error && saveServices.error.content && saveServices.error.content[`myBMWAppExtraServices[${i}].duration`]}
              />
            </React.Fragment>
            :
            <span className="right picker-right">{(service.duration) ? Time.durationToMoment(service.duration, 'HH:mm').format('HH:mm') : ''}</span>
          }
          <div className={"d-flex"}>
            <Checkbox checked={true} disabled={true}>{service['mlItem'][intl.locale]}</Checkbox>
            {canWrite &&
              <LabelEncoder keys={Constants.SUPPORTED_LANGUAGES} labelId={service.id} onValidate={(values) => this.onValidateAdditionalService(values, 'myBMWAppExtraServices')} values={service.mlItem}>
                  <span>
                    &nbsp;
                    <a className={"smaller"}>{intl.formatMessage({id: 'action.edit'})}</a>
                    &nbsp;
                    <a className={"smaller"} onClick={(e) => this.removeAdditionalService(e, service.id, 'myBMWAppExtraServices')}>{intl.formatMessage({id: 'action.delete'})}</a>
                  </span>
              </LabelEncoder>
            }
          </div>
        </li>
      )}
      {canAddMyBmwAppExtraService &&
        <li className="list__footer">
          <LabelEncoder keys={Constants.SUPPORTED_LANGUAGES} labelId={uuidv4()} onValidate={(values) => this.onValidateAdditionalService(values, 'myBMWAppExtraServices')}>
            <Button className="btn btn-link js-dropdown-trigger add-more-btn">
              <svg className="bmw-icon-sm mr-1" aria-hidden="true">
                <use xlinkHref="#icon-plus"/>
              </svg>
              <strong>{intl.formatMessage({id: 'add.more'})}</strong>
            </Button>
          </LabelEncoder>
        </li>
      }
    </ul>

  }

  render() {

    const {intl: {formatMessage}, fetchServices, loading, saveServices, configurationHints} = this.props;
    const {mainServices = {}, otherServices = {}, additionalServices = {}, myBMWAppServices = {}} = fetchServices.services;
    const {services} = this.state;
    const user = Storage.getItem('user');
    const canWrite= user.role === 'DUI_ADMIN';
    const canAddService = !services.extraServices || services.extraServices.length < MAX_SERVICES_TO_ADD;

    const mainServicesList = [];
    Object.keys(mainServices).forEach((key)=> {
      mainServicesList.push(mainServices[key]);
    });
    mainServicesList.sort((a, b)=>a.order - b.order);
    const otherServicesList = [];
    Object.keys(otherServices).forEach((key)=> {
      otherServicesList.push(otherServices[key]);
    });
    otherServicesList.sort((a, b)=>a.order - b.order);
    const additionalServicesList = [];
    Object.keys(additionalServices).forEach((key)=> {
      additionalServicesList.push(additionalServices[key]);
    });
    additionalServicesList.sort((a, b)=>a.order - b.order);

    const myBMWAppServicesList = Object.values(myBMWAppServices).sort((a, b) => a.order - b.order);

    const {error:{content:errors ={}} = {}}= saveServices;

    const requiredConfig = configurationHints.includes('SERVICES');

    return (
        <section className="box">
          <header className="box-heading">
            <h2 className="box-heading__title">
              {formatMessage({id: 'section.main-services.title'})}
            </h2>
            {canWrite &&
              <div className="box-heading__button">
                <button onClick={this.save} disabled={loading} type="primary" className="btn btn-sm btn-primary">
                  {formatMessage({id: 'action.save'})}
                </button>
              </div>
            }
          </header>
          {
            <div className="box__body">
              <SpinnerModal visible={loading}/>

              {requiredConfig && <div className={"alert alert--error"}>{formatMessage({id: 'section.requires-configuration'}, {sectionName: formatMessage({id: 'section.main-services.maintenance.title'})})}</div>}

              <div className="row">
                <div className="col-md-6 col-xxl-6">
                  <h3 className="box__subtitle">{formatMessage({id:'section.main-services.maintenance.title'})}</h3>

                  <ul className="list li-margin">
                    {mainServicesList.map((s, index)=><li key={s.name}>{this.renderDefaultItem(s, errors, canWrite)}</li>)}
                  </ul>
                </div>
                <div className="col-md-6 col-xxl-6">
                  <h3 className="box__subtitle">{formatMessage({id:'section.main-services.other.title'})}</h3>

                  <ul className="list li-margin">
                    {otherServicesList.map(s=><li key={s.name}>{this.renderOtherItem(s, errors, canWrite)}</li>)}
                  </ul>
                </div>
              </div>
              <Divider/>
              <div className="row">
                <div className="col-md-6 col-xxl-6">
                  <h3 className="box__subtitle">
                    {`${formatMessage({id:'section.additional-services.title'})} (${formatMessage({id: 'include.vat'})})`}
                  </h3>

                  <ul className="list li-margin">
                    {additionalServicesList.map(s=><li key={s.name}>{this.renderAdditionalItem(s, errors, canWrite)}</li>)}
                  </ul>
                </div>

                <div className="col-md-6 col-xxl-6">
                  <h3 className="box__subtitle">
                    {`${formatMessage({id:'section.extra-services.title'})} (${formatMessage({id: 'include.vat'})})`}
                  </h3>

                  <ul className="list li-margin">
                    {this.renderExtraServices()}
                    {canAddService && canWrite &&
                    <li className="list__footer">
                      <LabelEncoder keys={Constants.SUPPORTED_LANGUAGES} labelId={this.state.additionalServiceId} onValidate={this.onValidateExtraService}>
                        <Button className="btn btn-link js-dropdown-trigger add-more-btn">
                          <svg className="bmw-icon-sm mr-1" aria-hidden="true">
                            <use xlinkHref="#icon-plus"/>
                          </svg>
                          <strong>{formatMessage({id:'add.more'})}</strong>
                        </Button>
                      </LabelEncoder>
                    </li>}
                  </ul>
                </div>
              </div>

              <div>
                <Divider/>
                <div className="row">
                  <div className="col-md-6 col-xxl-6">
                    <h3 className="box__subtitle">
                      {`${formatMessage({id: 'section.my-bmw-app-services.title'})}`}
                    </h3>
                    <ul className="list li-margin">
                      {myBMWAppServicesList.map((s) => <li key={s.name}>{this.renderMyBMWAppItem(s, errors, canWrite)}</li>)}
                    </ul>
                  </div>

                  <div className="col-md-6 col-xxl-6">
                    <h3 className="box__subtitle">
                      {`${formatMessage({id: 'section.my-bmw-app-extra-services.title'})}`}
                    </h3>
                    {this.renderMyBMWAppExtraServices(errors, canWrite)}
                  </div>
                </div>
              </div>

            </div>
          }
        </section>
    );
  }
}

const mapStateToProps = state => ({
  configurationHints: (state.dealerConfigurationCheck && state.dealerConfigurationCheck.configurationHints) || [],
  fetchServices: state.fetchServices,
  saveServices: state.saveServices,
  loading: state.fetchServices.loading || state.saveServices.loading,
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchServices: (parameters, filters) => dispatch({type: 'FETCH_SERVICES.REQUEST', parameters, filters}),
  dispatchSaveServices: (body) => dispatch({type: 'SAVE_SERVICES.REQUEST', body})
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(withAuthorization(MainServices, ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR'])));



// WEBPACK FOOTER //
// ./src/components/dealership/MainServices.js